import {
  SET_EVENT_ROW_COLLAPSED
} from 'Store/constants';

const initialState = {
  isEventRowCollapsed: false
};

const collapseReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_EVENT_ROW_COLLAPSED:
      return {
        ...state,
        isEventRowCollapsed: action.payload
      };
    default:
      return state;
  }
};

export default collapseReducer;
